import { render, staticRenderFns } from "./examination-paper-select-modal.vue?vue&type=template&id=2db96ef1"
import script from "./examination-paper-select-modal.vue?vue&type=script&lang=js"
export * from "./examination-paper-select-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports